/**
 * Shared tier configuration — single source of truth for plan credits, limits, and pricing.
 * Must match the pricing page (subscription-payment).
 */
const tierConfig = {
  free:          { label: 'Free',        color: 'text-white/60',    monthlyCredits: 10,    projectsLimit: 3,     designsLimit: 20,     priceMonthly: 0,   priceAnnual: 0 },
  solo:          { label: 'Solo',        color: 'text-orange-300',  monthlyCredits: 250,   projectsLimit: 10,    designsLimit: 100,    priceMonthly: 19,  priceAnnual: 15 },
  pro:           { label: 'Pro',         color: 'text-orange-400',  monthlyCredits: 560,   projectsLimit: 20,    designsLimit: 500,    priceMonthly: 34,  priceAnnual: 27 },
  team:          { label: 'Team',        color: 'text-orange-500',  monthlyCredits: 1800,  projectsLimit: 50,    designsLimit: 2000,   priceMonthly: 119, priceAnnual: 99 },
  team_member:   { label: 'Team Member', color: 'text-yellow-300',  monthlyCredits: 0,     projectsLimit: 0,     designsLimit: 0,      priceMonthly: 0,   priceAnnual: 0 },
  enterprise:    { label: 'Enterprise',  color: 'text-purple-400',  monthlyCredits: 99999, projectsLimit: 99999, designsLimit: 99999,  priceMonthly: 0,   priceAnnual: 0 },
};

export const getTierInfo = (tier) => tierConfig[tier?.toLowerCase() || 'free'] || tierConfig.free;

export default tierConfig;
